import {provideSingleton, lazyInject} from './inversify';


@provideSingleton(LocalDataService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service
export class LocalDataService {
    public storage: any = null;
    constructor() {
        this.storage = localStorage;
    }
    add(key: string, data: any){
        if (!this.storage.getItem(key)) {
            this.storage.setItem(key, JSON.stringify([]));
        }
        const arr = JSON.parse(this.storage.getItem(key));
        arr.push(data);
        this.storage.setItem(key, JSON.stringify(arr));
        // console.log('STORAGE:');
        // console.log(this.storage);
        // console.log('QUEUE:');
        // console.log(arr);

    }
    removeFirst(key: string) {  // Gibt die Anzahl der verbleibenden Elemente zurück
        if (!this.storage.getItem(key)) {
            return;
        }
        const arr = JSON.parse(this.storage.getItem(key));
        arr.shift();
        const rest = arr.length;
        this.storage.setItem(key, JSON.stringify(arr));
        return rest;
    }
    count(key: string) {  // Gibt die Anzahl der verbleibenden Elemente zurück
        if (!this.storage.getItem(key)) {
            return 0;
        }
        const arr = JSON.parse(this.storage.getItem(key));
        return arr.length;
    }
    getFirst(key: string) {
        if (!this.storage.getItem(key)) {
            return;
        }
        const arr = JSON.parse(this.storage.getItem(key));
        if(arr.length > 0){
            return arr[0];
        }
    }
    set(key: string, data: any) {
        this.storage.setItem(key, data);
    }

    get(key: string) {
        return this.storage.getItem(key);
    }

    has(key: string) {
        return (this.storage.getItem(key) !== undefined);
    }

    remove(key: string) {
        return this.storage.removeItem(key);
    }

    clear() {
        this.storage.clear();
        console.log('STORAGE:');
        console.log(this.storage);
    }
    getAllKeys() {
        const keys = [];
        for (let i = 0; i < this.storage.length; i++) {
            const key_split = this.storage.key(i).split(',');
            keys.push(key_split[0]);
        }
        return keys;
    }

}
